import Button from 'components/atoms/Button'
import styled from 'styled-components'
import { DEVICES } from 'theme/devicesSizes'

export const BoxDirectAccess = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  flex-wrap: nowrap;
  margin-top: 24px;
  @media ${DEVICES.mobile} {
    margin-left: 8px;
    margin-right: 8px;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-top: 25px;
  width: 45%;
`

export const ModalDescription = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ModalButton = styled(Button)`
  margin-bottom: 10px;
`
